import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { StorageService } from '@src/app/core/services/storage.service';

export interface BannerSlide {
  title: string;
  subtitle: string;
  discription: string;
  buttonText: string;
  buttonText3: string;
  buttonAction?: string;
  buttonText2: string;
  buttonAction1?: string;
  buttonAction2?: string;
  bgImageUrl: string; // Changed from imageUrl
  link: string;
  customStyle: string;
  bannerClass: string;
  action: string;
  info: string;
  text: string;
}

@Component({
  selector: 'app-mini-env-banner',
  imports: [CommonModule],
  templateUrl: './mini-env-banner.component.html',
  styleUrl: './mini-env-banner.component.scss'
})
export class MiniEnvBannerComponent {
  @Input() slides: BannerSlide[] = [];
  @Input() subDescription = '';
  @Input() bgColor: string = '';
  @Output() butonAction = new EventEmitter();
  storageService = inject(StorageService)
  currentIndex = 0;
  autoPlayInterval: any;
  removeButtonsAfterLogin = false
  ngOnInit() {
    if (this.slides.length > 1) {
      this.startAutoPlay();
    }
    if (this.storageService.getUserInformation() && this.storageService.getMiniEnvConfig()?.removeButtonsAfterLogin) {
    this.removeButtonsAfterLogin = true
    }
  }

  setCurrentSlide(index: number) {
    this.currentIndex = index;
    this.resetAutoPlay();
  }

  startAutoPlay() {
    this.autoPlayInterval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }, 5000); // 5 seconds
  }

  buttonAction(action: any) {
    this.butonAction.emit(action);
  }

  resetAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.startAutoPlay();
    }
  }

  ngOnDestroy() {
    if (this.autoPlayInterval) clearInterval(this.autoPlayInterval);
  }
}
